import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import PageContainer from '../page-container';
import Component from './component';
import Loader from '../../components/loader';

import Triggers from '../../../lib/triggers';

export default () => {
    const location = useLocation();

    useEffect(() => {
        Triggers.page_view({
            page: "not_found"
        });
    }, [location]);

    useEffect(() => {
        Loader.close();
    }, []);

    return (
        <PageContainer>
            <Component />
        </PageContainer>
    )
}